<template>
  <v-layout>

    <v-flex>
      <v-row align="center" no-gutters class="">
        <v-col class="text-left ml-n6 mt-n4">
          <v-breadcrumbs :items="subNavs"></v-breadcrumbs>
        </v-col>
      </v-row>

      <v-card class="pa-6 mt-3">
        <v-card-title>
          Client
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text class="text--primary mt-6">

          <v-row class="pa-0">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="user.code"
                maxlength="100"
                label="Code"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="user.first_name"
                maxlength="100"
                label="First Name"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="user.last_name"
                maxlength="100"
                label="Last Name"
                readonly
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="user.email"
                maxlength="100"
                label="Email Address"
                hint="* Required (e.g. juan.delacruz@email.com)"
                show-details
                readonly
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="user.contact_no"
                maxlength="50"
                label="Contact No."
                readonly
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="user.company"
                maxlength="150"
                label="Company"
                readonly
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-select
                v-model="user.location_id"
                :items="locations"
                menu-props="auto"
                label="Overseas Warehouse"
                item-text="name"
                item-value="id"
                readonly
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="user.warehouse_id"
                :items="warehouses"
                menu-props="auto"
                label="Warehouse"
                item-text="name"
                item-value="id"
                readonly
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-textarea
                v-model="user.address"
                label="Address"
                auto-grow
                rows="1"
                readonly
                maxlength="255"
                value="">
              </v-textarea>
            </v-col>
            <v-col cols="12" md="4">
              <v-switch
                v-model="user.bill_to_company"
                label="Bill to Company?"
                class="mb-4"
                readonly
              ></v-switch>
            </v-col>
          </v-row>
        </v-card-text>

      </v-card>
      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
    </v-flex>
  </v-layout>
</template>

<script>
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  export default {
    name: 'AccountingClientViewPage',
    data: () => ({
      accountingNamespace: 'accounting',
      slug: '',
      loading: false,
      subNavs: [
        {
          text: 'Clients',
          disabled: false,
          exact: true,
          to: {
            name: 'clients'
          },
        },
        {
          text: 'Client',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      warehouses: [],
      locations: [],
      user: {
        email: '',
        first_name: '',
        last_name: '',
        contact_no: '',
        warehouse_id: '',
        location_id: '',
        address: ''
      }
    }),
    computed: {
    },
    methods: {
      getDefaultData () {
        let self = this
        this.$http.plain.get(this.accountingNamespace+'/default-data?warehouses=true&locations=true')
          .then(response => {
            this.warehouses = response.data.warehouses
            this.locations = response.data.locations
          })
          .catch(error => {
            console.log(error);
          })
      },
      getClient () {
        this.loading = true
        let self = this
        this.$http.plain.get(this.accountingNamespace+'/clients/'+this.slug)
          .then(response => {
            this.user = response.data
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      }
    },
    mounted() {
      this.slug = this.$route.params.slug
      this.getClient()
      this.getDefaultData()
    },
    components: {
      SnackBar
    }
  }
</script>
